import {
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

import { EngeneFileObject } from '../../models/EngeneFileObject';
import { useSizeContext } from '../SizeProvider';

export type ImageModalProps = {
  isOpen?: boolean;
  onClose: Runnable;
  file?: EngeneFileObject;
};

/**
 *
 * @returns
 */
export const ImageModal: React.FunctionComponent<ImageModalProps> = ({
  file,
  isOpen,
  onClose,
}) => {
  const sizes = useSizeContext();

  const handleClose = React.useCallback(() => {
    onClose();
  }, []);

  return (
    <Modal isOpen={!!isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize={sizes.fontSize.modalHeader}>
          {file?.fileName}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Image src={file?.objectUrl || file?.getUrl('view')} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
